<div class="popup">
	<div class="popup-header">
		<h1>{{'SICK_DAY.ANSWER_TO_SICK_DAY' | translate}}</h1>
	</div>
	<div class="popup-body">
		<div class="sick-day-holder">
			<div class="qo-padding30  qo-flex-row-space-between">
				<div class="qo-flex-row-top-left">
					<qo-profile-image
						[imageUrl]="data.sickDay?.shift.user.profile_picture?.download_url"
						[letter]="data.sickDay?.shift.user.getInitials()"
						[size]="40"
						[fontSize]="20"
					></qo-profile-image>
					<div class="qo-flex-col-top-left qo-margin-left20">
						<h4>{{data.sickDay?.shift.user.getFullName()}}</h4>
						<div class="qo-flex-row-top-left qo-margin-top10 align-center">
							<qo-icon
								[icon]="EQORebrandIcon.sick_dark"
								[invertedScheme]="true"
								[scheme]="EQORebrandColor.NO"
								[color]="EQORebrandColor.NO"
								[size]="'sm'"
							></qo-icon>
							<span class="qo-margin-left10 qo-no">{{'SICK_DAY.SICK' | translate}}</span>
						</div>
					</div>
					<div class="qo-flex-col-top-right">
						<div>{{data.sickDay?.shift.start.format('DD/MM/YYYY')}}</div>
						<div class="qo-margin-top10">
							{{data.sickDay?.shift.start.localDate.format('HH:mm')}}
							- {{data.sickDay?.shift.end.localDate.format('HH:mm')}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="qo-flex-col-top-left qo-margin-top20">
			<div
				class="qo-flex-row-space-between padding-mobile"
				*ngFor="let answer of (answers$ | async)"
			>
				<div class="qo-flex-row-top-left align-center">
					<qo-profile-image
						[imageUrl]="answer.user.profile_picture?.download_url"
						[letter]="answer.user.getInitials()"
						[size]="40"
						[fontSize]="18"
					></qo-profile-image>
					<h4 class="qo-margin-left15">{{answer.user.getFullName()}}</h4>
				</div>
				<div
					class="sick-label flex-center"
					[ngClass]="answer.status === ANSWER.STATUS_CAN_TAKE ? 'green-label': 'grey-label'"
					*ngIf="authService.windowWidth >= SCREEN.XS"
					[ngSwitch]="answer.status"
				>
					<ng-container *ngSwitchCase="ANSWER.STATUS_CAN_TAKE">{{'SICK_DAY.CAN_TAKE' | translate}}</ng-container>
					<ng-container *ngSwitchCase="ANSWER.STATUS_CANNOT_TAKE">{{'SICK_DAY.CAN_NOT_TAKE' | translate}}</ng-container>
					<ng-container *ngSwitchCase="ANSWER.STATUS_NOT_SEEN">{{'SICK_DAY.NOT_SEEN' | translate}}</ng-container>
					<ng-container *ngSwitchCase="ANSWER.STATUS_SEEN">{{'SICK_DAY.SEEN' | translate}}</ng-container>
				</div>
				<div class="qo-flex-col-top-right">
					<button
						class="qo-button-small qo-primary"
						[class.qo-button-loader]="isLoading$ | async"
						[disabled]="isLoading$ | async"
						(click)="allocateShift(answer.user)"
					>
						{{'SICK_DAY.ALLOCATE_SHIFT' | translate}}
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="qo-flex-row-top-right qo-padding30 mobile-absolute white-footer">
		<button
			class="qo-button-standard qo-grey"
			(click)="close()"
		>{{'GLOBAL.CLOSE' | translate}}</button>
	</div>
</div>
